import { render } from "./radio.vue?vue&type=template&id=0e8d8b8f&scoped=true"
import script from "./radio.vue?vue&type=script&lang=js"
export * from "./radio.vue?vue&type=script&lang=js"

import "./radio.vue?vue&type=style&index=0&id=0e8d8b8f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src859495510/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8d8b8f"]])

export default __exports__